import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import IncomeRequired from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import { incomePaymentDetailsLabels, incomePaymentDetailsMessages } from "../../Resource/Contents";
import { ClientDetails } from "./ClientDetails";
import { PensionDetails } from "./PensionDetails";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { MoneyHelper } from "../../../../../../Shared/Common/MoneyHelper";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import {
    getSellableAssets,
    getUpdatedAssetsToSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { CappedFlexiSection } from "../../../Common/SIPP/IncomePaymentDetails/CappedFlexiSection";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { 
    getAssetsToSellTotalForIncomeFromIncome,
    calculateBalanceFrequency,
    frequencyMap,
} from "../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { UserStore } from "../../../../../Stroes/Variable";
import { GENERIC_RESTRICTIONS_MESSAGE } from "../../../../../../Shared/Common/UserMessages";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import IncomeBankDetails from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { Action } from "../../../../../Actions/Action";
import { BankAccount } from "../../../../../../../Wrap/Models/Domains/BankAccount/BankAccount";
import { VerificationCheckStatus } from '../../../../../../../Wrap/Constants/Enums/Domain/VerificationCheckStatus';
import { IncomePaymentDestination } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    extraInfo?: any;
    disableWithdraw?: boolean;
    arrangementId?: number;
}

interface IIncomePaymentDetailsState {
    isIncomeRequired: boolean;
    assets: ChooseAssetsToSellAssets[];
    userInfo: User;
    isLoading: boolean;
    hasSubmittedIncomeReview: boolean;
    verifiedBankAccounts: BankAccount[];
    initialTargetSpecificArrangements?: boolean; 
    showCancelWarning: boolean;
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    constructor(props: any) {
        super(props);
        const income = this.props.data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
            ?.Income;
        const cappedArrangements = this.props.data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements??[]
            
        this.state = {
            userInfo: UserStore.getUserInfo(),
            assets: null,
            isIncomeRequired:
                income?.GrossIncomePerPayment?.Amount > 0 || income?.GrossIncomePerPaymentFromPension?.Amount > 0 || (income.TargetSpecificArrangements && cappedArrangements.some(x => x.IncomePerPaymentForFuturePensionYears > 0)),
            isLoading: false,
            hasSubmittedIncomeReview: false,
            verifiedBankAccounts: null,
            initialTargetSpecificArrangements:income?.TargetSpecificArrangements,
            showCancelWarning: false,
        };
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                const updateAssets = getUpdatedAssetsToSell([], 0, data?.assetsToSell);
                this.setState({ assets: updateAssets });
            });
        });
    };

    private getPensionSubAccountSetting = () => {
        const params = getQueryParameters();
        const subaccountHierarchyId = params["subaccounthierarchyid"];
        Action.getPensionSubAccountSettings(subaccountHierarchyId, true, (val) => {
            this.setState({
                    hasSubmittedIncomeReview: val?.HasSubmittedIncomeReview ?? false
                }
            );
        });
    };

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();
        this.getPensionSubAccountSetting();
        this.getVerifiedBankAccounts();

        const instruction = this.props.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction;
        if (!isNullOrEmpty( instruction?.IncomeDisinvestmentAllocations)){
            this.props.onChange({ IsAcrossAllAssets: false });
        }

        if (instruction?.Income?.NextPayment && instruction?.Income?.Frequency) {
            this.updateMaxIncomePayment();
        }
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);

        const curIncome = this.props.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income;
        const preIncome = prevProps.data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income;
        if (curIncome?.Frequency != preIncome?.Frequency || curIncome?.NextPayment != preIncome?.NextPayment) {
            this.updateMaxIncomePayment();
        }
    }

    private updateMaxIncomePayment = () => {
        const { data } = this.props;
        const income = data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income;
        const cappedArrangements = data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements;

        const updatedCapped = cappedArrangements?.map((item) => ({...item}));
        updatedCapped?.forEach((item) => {
            const remainder = item.GadMaximum - item.IncomeTakenToDate;
            const balanceFrequency = calculateBalanceFrequency(item.GadStartDate, income.NextPayment, income.PaymentEnd, income.Frequency);

            item.MaximumIncomePaymentForRemainderOfPensionYear = Math.floor((balanceFrequency && remainder / balanceFrequency) * 100) / 100;
            item.MaximumIncomePaymentForFuturePensionYears = Math.floor((item.NextYearsGadMaximum || item.GadMaximum) / frequencyMap[income.Frequency] * 100) / 100;
        })

        this.handleChange(updatedCapped, "CappedArrangements");
    }

    isValid() {
        if (this.state.hasSubmittedIncomeReview) {
            this.props.showErrorMsgPopUp([incomePaymentDetailsMessages.hasSubmittedIncomeReviewErrorMsg]);
        }

        return super.isValid() && !this.state.hasSubmittedIncomeReview;
    }

    private handleChange(changes, key?: string) {
        const { data, onChange } = this.props;
        const model = data?.Contribution.DrawdownIncomeAmendmentModel ?? { DrawdownIncomeAmendmentInstruction: {} };
        this.onDataChange(
            (changes) => {
                this.onDataChange(
                    (changes) => {
                        this.onDataChange(
                            (changes) => {
                                this.onDataChange(onChange, changes, data, "Contribution");
                            },
                            changes,
                            data.Contribution,
                            "DrawdownIncomeAmendmentModel"
                        );
                    },
                    changes,
                    model,
                    "DrawdownIncomeAmendmentInstruction"
                );
            },
            changes,
            model.DrawdownIncomeAmendmentInstruction,
            key
        );
    }
    private handleDrawdownIncomeModelChange(changes, key?: string) {
        const { data, onChange } = this.props;

        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "Contribution");
            },
            changes,
            data.Contribution,
            "DrawdownModel"
        );
    }

    private getVerifiedBankAccounts() {
        const { extraInfo } = this.props;

        let verifiedBankAccounts = [];
        extraInfo?.AllBankAccounts?.forEach((value) => {
            if (value.VerificationStatus == VerificationCheckStatus.Passed) {
                verifiedBankAccounts.push(value);
            }
        })

        this.setState({ verifiedBankAccounts: verifiedBankAccounts });
    }   

    public render(): JSX.Element {
        const { data, onChange, extraInfo, arrangementId } = this.props;
        const income =
        data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income;
        
        let restrictedMessage = "An account with suspended or restricted activities cannot setup income payment";

        if (this.state.userInfo != null && this.state.userInfo.IsAdviser) {
            restrictedMessage = GENERIC_RESTRICTIONS_MESSAGE;
        }
        const existingArrangements = {
            FlexiModels:
                data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.FlexiArrangements,
            CappedModels:
                data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements,
        };
        const hasBankDestination = data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations?.some(alloc => alloc.Destination == IncomePaymentDestination.BankAccount);
        const arrangementValuationForGadReview = data?.Contribution?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements?.find(x => x.PensionArrangementId == arrangementId)?.Amount ?? 0;
        return (
            <div className="col-md-10 col-12">
                <h2>Income payment details</h2>
                {this.props.disableWithdraw && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <div>
                    <FinancialAdvice
                        data={data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction}
                        onChange={(v) => {
                            this.onDataChange(
                                (changes) => {
                                    this.onDataChange(
                                        (changes) => {
                                            this.onDataChange(onChange, changes, data, "Contribution");
                                        },
                                        changes,
                                        data.Contribution,
                                        "DrawdownIncomeAmendmentModel"
                                    );
                                },
                                v,
                                data.Contribution.DrawdownIncomeAmendmentModel,
                                "DrawdownIncomeAmendmentInstruction"
                            );
                        }}
                        onRef={(ref) => this.appendChild(ref)}
                    />
                    <hr />
                    <ClientDetails data={data?.ClientDetails} />
                    <PensionDetails
                        data={
                            data?.Contribution.DrawdownIncomeAmendmentModel
                                ?.PensionLevelDrawdownIncomeAmendmentCalculations?.CappedArrangementsIncomeDetail
                        }
                        arrangementId={arrangementId}
                        arrangementValuationForGadReview={arrangementValuationForGadReview}
                    />
                    <RadiosEditor
                        cssWrapper="rg-inline mb-16"
                        label={incomePaymentDetailsLabels.incomeRequired}
                        selected={this.state.isIncomeRequired}
                        options={[true, false]}
                        getText={(v) => (v ? "Yes" : "No")}
                        onChange={(v) => {
                            const wasIncomeRequired = this.state.isIncomeRequired;
                            const turningOff = wasIncomeRequired && !v;   
                        
                            this.setState({ isIncomeRequired: v, showCancelWarning: turningOff });                            
                            if (!v) {
                                this.onDataChange(
                                    (changes) => {
                                        this.onDataChange(
                                            (changes) => {
                                                this.onDataChange(onChange, changes, data, "Contribution");
                                            },
                                            changes,
                                            data.Contribution,
                                            "DrawdownIncomeAmendmentModel"
                                        );
                                    },
                                    v,
                                    data.Contribution.DrawdownIncomeAmendmentModel,
                                    "DrawdownIncomeAmendmentInstruction"
                                );
                                this.handleChange({
                                    GrossIncomePerPayment: { Amount: 0, Currency: CurrencyCode.GBP },
                                    CurrentYearIncome: { Amount: 0, Currency: CurrencyCode.GBP },
                                    AnnualAmount : { Amount: { Amount: 0, Currency: CurrencyCode.GBP } },
                                    TaxableIncomeRequiredInAddition: v,
                                }, "Income");
                            }
                            else {
                                this.setState({ showCancelWarning: false });
                            }
                        }}
                    />
                    {this.state.showCancelWarning && (
                    <>
                        {this.state.initialTargetSpecificArrangements === false && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={incomePaymentDetailsMessages.cancelIncomeTargetNo}
                        />
                        )}

                        {this.state.initialTargetSpecificArrangements === true && (
                        <Alert
                            alertType={AlertType.Warning}
                            message={incomePaymentDetailsMessages.cancelIncomeTargetYes}
                        />
                        )}
                    </>
                    )}

                    {this.state.isIncomeRequired &&
                    income?.TargetSpecificArrangements === true && (
                        <Alert
                        alertType={AlertType.Warning}
                        message={incomePaymentDetailsMessages.amendIncomeTargetYes}
                        />
                    )}  
                    
                    {this.state.isIncomeRequired && (
                        <>                         
                            <IncomeRequired
                                data={
                                    data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
                                        ?.Income
                                }
                                onChange={(changes) => {
                                    this.handleChange(changes, "Income");
                                }}
                                labels={incomePaymentDetailsLabels}
                                messages={incomePaymentDetailsMessages}
                                onRef={(ref) => this.appendChild(ref)}
                                processType={processTypeEnum.GadReview}
                                drawdownType={extraInfo?.Drawdowntype}
                                pensionTransfer={[]}
                                pensionBase={data?.Contribution}
                                isITFC={false}
                            />
                            {data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.Income
                                ?.TargetSpecificArrangements &&
                                extraInfo?.Drawdowntype === DrawdownType.Capped && (
                                    <CappedFlexiSection
                                        data={existingArrangements}
                                        onChange={(changes, type) => {
                                            const convertedChanges =
                                                type === "CappedModels" ? changes?.CappedModels : changes?.FlexiModels;
                                            const convertedKey =
                                                type === "CappedModels" ? "CappedArrangements" : "FlexiArrangements";

                                            this.onDataChange(
                                                (changes) => {
                                                    this.onDataChange(
                                                        (changes) => {
                                                            this.onDataChange(onChange, changes, data, "Contribution");
                                                        },
                                                        changes,
                                                        data.Contribution,
                                                        "DrawdownIncomeAmendmentModel"
                                                    );
                                                },
                                                { [convertedKey]: convertedChanges },
                                                data.Contribution.DrawdownIncomeAmendmentModel,
                                                "DrawdownIncomeAmendmentInstruction"
                                            );
                                        }}
                                        income={
                                            data?.Contribution?.DrawdownIncomeAmendmentModel
                                                ?.DrawdownIncomeAmendmentInstruction?.Income
                                        }
                                        onIncomeChange={(changes) => this.handleChange(changes, "Income")}
                                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                        onRef={(ref) => this.appendChild(ref)}
                                        drawdownType={extraInfo?.Drawdowntype}
                                        isGADReview={true}
                                        processType={processTypeEnum.GadReview}
                                    />
                                )}
                            <RegularIncomePayment
                                data={
                                    data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
                                        ?.Income
                                }
                                onChange={(changes) => {
                                    this.handleChange(changes, "Income");
                                }}
                                labels={incomePaymentDetailsLabels}
                                messages={incomePaymentDetailsMessages}
                                shouldHidePaymentMethod={!hasBankDestination}
                                onRef={(ref) => this.appendChild(ref)}
                                drawdownType={extraInfo?.Drawdowntype}
                                pensionBase={data?.Contribution}
                                processType={processTypeEnum.GadReview}
                                isITFC={false}
                                pensionYearEndDate={
                                    data?.Contribution.DrawdownIncomeAmendmentModel?.PensionLevelDrawdownIncomeAmendmentCalculations?.CappedArrangementsIncomeDetail?.filter(
                                        (ele) => ele?.ArrangementId == arrangementId
                                    )[0]?.PensionYearStart
                                }
                                nextPensionYearMinimalPaymentDate={data?.Contribution.DrawdownIncomeAmendmentModel?.PensionLevelDrawdownIncomeAmendmentCalculations?.CappedArrangementsIncomeDetail?.filter(
                                        (ele) => ele?.ArrangementId == arrangementId
                                    )[0]?.NextPensionYearMinimalPaymentDate}
                                subaccountHierarchyid={getQueryParameters()["subaccountHierarchyid"]}
                                sellableAssets={this.state.assets}
                            />
                            {this.state.assets != null &&
                                <ChooseAssetsToSell
                                    data={{
                                        IsAcrossAllAssets: data?.Contribution?.DrawdownModel?.IsAcrossAllAssets,
                                    }}
                                    onChange={(value) => this.handleDrawdownIncomeModelChange(value, "IsAcrossAllAssets")}
                                    sectionHeader={`Choose assets to sell to pay income (${MoneyDisplayHelper.FromatMoneyDisplay(
                                        getAssetsToSellTotalForIncomeFromIncome(
                                            data?.Contribution.DrawdownIncomeAmendmentModel
                                                ?.DrawdownIncomeAmendmentInstruction?.Income
                                        ),
                                        MoneyHelper.getDefaultCurrency()
                                    )})`}
                                    onRef={(ref) => this.appendChild(ref)}
                                    assets={this.state.assets}
                                    processType={processTypeEnum.GadReview}
                                    tableKey={TableKeys.IncomeDisinvestmentAllocations}
                                />
                            }
                            {!(data?.Contribution?.DrawdownModel?.IsAcrossAllAssets ?? true) && (
                                <ChooseAssetsToSellTable
                                    data={
                                        data?.Contribution.DrawdownIncomeAmendmentModel
                                            ?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations ?? []
                                    }
                                    isAcrossAllAssets={data?.Contribution?.DrawdownModel?.IsAcrossAllAssets}
                                    tableData={this.state.assets}
                                    modelData={{ DrawdownType: DrawdownType.Capped }}
                                    reason={ChooseAssetsToSellFor.Income}
                                    onRef={(ref) => this.appendChild(ref)}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => {
                                                this.onDataChange(
                                                    (changes) => {
                                                        this.onDataChange(onChange, changes, data, "Contribution");
                                                    },
                                                    changes,
                                                    data.Contribution,
                                                    "DrawdownIncomeAmendmentModel"
                                                );
                                            },
                                            { IncomeDisinvestmentAllocations: v },
                                            data.Contribution.DrawdownIncomeAmendmentModel,
                                            "DrawdownIncomeAmendmentInstruction"
                                        );
                                    }}
                                    processType={ProcessType.GadReview}
                                    gadReviewtotalValue={getAssetsToSellTotalForIncomeFromIncome(
                                        data?.Contribution.DrawdownIncomeAmendmentModel
                                            ?.DrawdownIncomeAmendmentInstruction?.Income
                                    )}
                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                />
                            )}
                            <hr />
                            <IncomeBankDetails
                                data={
                                    data?.Contribution.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction
                                        ?.Income?.IncomePaymentAllocations ?? []
                                }
                                onChange={(value) => {
                                    this.handleChange({ IncomePaymentAllocations: value }, "Income");
                                }}
                                bankAccountInstructions={data?.BankAccountInstructions}
                                onRef={(ref) => this.appendChild(ref)}
                                allBankAccounts={this.state.verifiedBankAccounts}
                                processType={ProcessType.GadReview}
                                showPropotionOfIncome={this.state.isIncomeRequired}
                                onChangeBankAccountInstructions={(changes) => {
                                    this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                                }}
                            />
                        </>
                    )}
                </div>
            </div>
        );
    }
}